import type { ReactElement } from 'react';
import { Button, Dropdown } from 'antd';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';

type Props = {
  onOpenComparison: () => void;
  onExportCsv: (withBom: boolean) => void;
  disabled: boolean;
};

const ActionButtons = (props: Props): ReactElement => {
  const { onOpenComparison, onExportCsv, disabled } = props;
  const { t } = useTranslation();

  return (
    <ButtonContainer>
      <Button onClick={onOpenComparison}>{t('compare')}</Button>
      <Dropdown
        disabled={disabled}
        menu={{
          items: [
            {
              key: 'csv',
              label: t('csvDownloadUtf8'),
              onClick: (): void => {
                onExportCsv(false);
              },
            },
            {
              key: 'csv-bom',
              label: t('csvDownloadUtf8Bom'),
              onClick: (): void => {
                onExportCsv(true);
              },
            },
          ],
        }}
        trigger={['click']}
      >
        <Button>{t('csvDownload')}</Button>
      </Dropdown>
    </ButtonContainer>
  );
};

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 4px;
  width: 100%;
`;

export { ActionButtons };
